@if(expandMenuDrawer$ | async){}
<div class="mobile-view-filters h-full flex">
  <div class="h-full drawer-hide-when-closed" [class.drawer-open]="!showFilters()" [class.drawer-closed]="showFilters()">
    <div class="mobile-view-filters-buttons h-full">
      <div class="mobile-view-filters-buttons-header flex align-items-center justify-content-between">
        <div class="mobile-view-filters-buttons-header-date flex flex-column align-items-start w-full flex-1">
          <span class="webkit-box-one-line body-small-regular">{{dateTime().date}}</span>
          <span class="webkit-box-one-line body-small-regular">{{dateTime().time}}</span>
        </div>
        <a class="cursor-pointer" (click)="closeMenu()">
          <em class="icon-x"></em>
        </a>
      </div>
      <button class="flex align-items-center w-full" (click)="showFiltersContent('region')">
        <div class="flex flex-column align-items-start">
          <span class="label label-small-regular">Regions</span>
          @if(selectedRegions.length > 0){
          <div class="webkit-box-one-line value label-large-medium">{{selectedRegions.length === 1 ? selectedRegions[0].name :
            selectedRegions[0].name + ' +' + selectedRegions.length}}</div>
          }@else {
          <div class="white-space-nowrap value label-large-medium">Select regions</div>
          }
        </div>
        <em class="ml-auto icon-caret-right"></em>
      </button>
      <button class="flex align-items-center w-full" (click)="showFiltersContent('location')">
        <div class="flex flex-column align-items-start">
          <span class="label label-small-regular">Locations</span>
          @if(selectedLocations.length > 0){
          <div class="webkit-box-one-line value label-large-medium">{{selectedLocations.length === 1 ? selectedLocations[0].name :
            selectedLocations[0].name + ' +' + selectedLocations.length}}</div>
          }@else {
          <div class="white-space-nowrap value label-large-medium">Select Locations</div>
          }
        </div>
        <em class="ml-auto icon-caret-right"></em>
      </button>
    </div>
  </div>
  <div class="h-full" [class.drawer-open]="showFilters()" [class.drawer-closed]="!showFilters()">
    <div class="flex flex-column gap-3  mobile-view-filters-section">
      <div class="flex align-items-center gap-12px">
        <button class="mobile-view-filters-section-back" (click)="showFilters.set(false)">
          <em class="icon-caret-left"></em>
        </button>
        <div class="mobile-view-filters-section-title body-large-bold">{{selectedFilterType() === 'region' ? 'Regions' : 'Locations'}}
        </div>
      </div>
      @if(selectedFilterType() !==null){
      <st-list-filter [ngClass]="{'hidden': selectedFilterType() !== 'region'}" [selectedFilterType]="'region'"
        [locations]="locations()" [regions]="regions()" [(selectedRegions)]="selectedRegions"
        (regionsChanged)="onRegionChange()" (selectedRegionsChange)="regionsChange(selectedRegions)"></st-list-filter>
      <st-list-filter [ngClass]="{'hidden': selectedFilterType() !== 'location'}"
        [(selectedLocations)]="selectedLocations " [selectedFilterType]="'location'"
        [locations]="locations() | locationsFilterPipe: selectedRegions" [regions]="regions()" (selectedLocationsChange)="locationsChange(selectedLocations)" (locationsChanged)="onLocationChange()"></st-list-filter>
      }
    </div>
  </div>
</div>